/**
 * Entry Point
 */

import "babel-polyfill";
import "classlist-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';

// Import Global Styles
import './styles/du.css';

// Import Main Driver
import App from './components/du/App/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/du.js